import { callEndpoint } from './apiUtils';
import 'whatwg-fetch';

export const oneWayMessagesApi = async (jwt: string) => {
  const response: OneWayMessageResponse = await callEndpoint(`one-way-messages`, jwt, 'GET');
  return response;
};
